import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 2,
    minHeight: '65.49vh',
    backgroundColor: themeColor.lightBackground,
  },
  titleItem: {
    height: '28.64vh',
  },
  titleContainer: {
    height: '7.29vh',
    backgroundColor: themeColor.white,
    border: `1px solid ${themeColor.secondaryLight}`,
    borderRadius: '2px',
    alignContent: 'center',
  },
  contentTitle: {
    height: '2.60vh',
    fontSize: rem(1.125),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '2.6vh',
    letterSpacing: '0.5px',
    color: themeColor.defaultTextColor,
    paddingLeft: '1.46vw',
  },
  icon: {
    display: 'inline-block',
    height: '2.8vh',
    width: '2.3vw',
    color: themeColor.alert,
    paddingRight: '1.46vw',
  },
  progressBar: {
    width: '14.64vw',
    height: '1vh',
    marginBottom: '3.90vh',
    backgroundColor: themeColor.progressBar,
    position: 'relative',
  },
  bar: {
    width: '0px',
    height: '100%',
    position: 'absolute',
    backgroundColor: theme.palette.secondary.main,
  },
  widthAnimation: {
    animation: `$width-animation 3s linear`,
  },
  '@keyframes width-animation': {
    '0%': {
      width: '0px',
    },
    '100%': {
      width: '100%',
    },
  },
  contentDescription: {
    height: '2.6vh',
    fontSize: rem(1.125),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '2.6vh',
    letterSpacing: '0.5px',
    color: themeColor.subheaderLight,
    paddingLeft: '1.46vw',
  },
}));
